// extracted by mini-css-extract-plugin
export default {"container":"Sellers_container__gz4Hr"};